import type { ArticleCard as ArticleCardType } from 'types/capi/shared';

import ArticleCard from '~/components/ArticleCard';

type Props = {
  items: ArticleCardType[];
};

export default function Highlights({ items }: Props) {
  const [hero, card1, card2, card3] = items;
  if (!hero || !card1 || !card2 || !card3) return null;

  return (
    <div className="w-full bg-grey-tile">
      <div className="content-width flex flex-col gap-6 py-10 md:py-20">
        <ArticleCard
          className="hidden sm:block"
          item={hero}
          name="LATEST_NEWS"
          options={{ titleSize: 'lg' }}
          pagePosition="Homepage Article Highlights"
          variant="16/9-text-over"
        />
        <ArticleCard
          className="block sm:hidden"
          item={hero}
          name="LATEST_NEWS"
          pagePosition="Homepage Article Highlights"
          variant="4/5-text-over"
        />

        <div className="carousel-width no-scrollbar flex gap-6 overflow-y-hidden">
          <ArticleCard
            item={card1}
            name="LATEST_NEWS"
            pagePosition="Homepage Article Highlights"
            variant="16/9-text-under"
          />
          <ArticleCard
            item={card2}
            name="LATEST_NEWS"
            pagePosition="Homepage Article Highlights"
            variant="16/9-text-under"
          />
          <ArticleCard
            item={card3}
            name="LATEST_NEWS"
            pagePosition="Homepage Article Highlights"
            variant="16/9-text-under"
          />
        </div>
      </div>
    </div>
  );
}
